export type SetupLinkKey = 'invoice' | 'payment' | 'payout' | 'subscription' | 'common';

/** Keys from checkSetup payload that are false / missing. */
export const getMissingSetupKeys = (data: Record<string, boolean> | null | undefined): SetupLinkKey[] => {
    if (!data) {
        return [];
    }
    return (Object.keys(data) as SetupLinkKey[]).filter((key) => data[key] === false);
};

export const isCheckSetupComplete = (data: Record<string, boolean> | null | undefined): boolean => {
    if (!data || Object.keys(data).length === 0) {
        return false;
    }
    return Object.values(data).every(Boolean);
};
